'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */
export default {
    init: function () {
    $('.slick').slick();
    }
}
